// Source de vérité unique pour les configs de statut (client + mandat).

// Bandeau de statut client (drawer / aperçu compact).
export const CLIENT_STATUS_BANNER = {
  prospect: { label: 'Prospect', bg: 'bg-slate-100', text: 'text-slate-700', ring: 'ring-slate-200', dot: 'bg-slate-400' },
  mandat_envoye: { label: 'Mandat envoyé', bg: 'bg-amber-50', text: 'text-amber-700', ring: 'ring-amber-200', dot: 'bg-amber-500' },
  signe: { label: 'Mandat signé', bg: 'bg-blue-50', text: 'text-blue-700', ring: 'ring-blue-200', dot: 'bg-blue-500' },
  actif: { label: 'Actif', bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200', dot: 'bg-emerald-500' },
  resilie: { label: 'Résilié', bg: 'bg-neutral-100', text: 'text-neutral-600', ring: 'ring-neutral-200', dot: 'bg-neutral-400' },
};

// Variante page complète : seul le libellé "mandat envoyé" est plus explicite.
export const CLIENT_STATUS_BANNER_DETAIL = {
  ...CLIENT_STATUS_BANNER,
  mandat_envoye: { ...CLIENT_STATUS_BANNER.mandat_envoye, label: 'Mandat envoyé — en attente' },
};

// Badge statut client dans la liste (label + class).
export const CLIENT_STATUS_BADGE = {
  prospect: { label: 'Prospect', class: 'bg-slate-100 text-slate-700' },
  mandat_envoye: { label: 'Mandat envoye', class: 'bg-amber-100 text-amber-700' },
  signe: { label: 'Signe', class: 'bg-blue-100 text-blue-700' },
  actif: { label: 'Actif', class: 'bg-emerald-50 text-emerald-700' },
  resilie: { label: 'Resilie', class: 'bg-red-100 text-red-700' },
};

// Chip statut client sur la fiche (label + cls).
export const CLIENT_STATUS_CHIP = {
  prospect: { label: 'Prospect', cls: 'bg-neutral-100 text-neutral-600' },
  mandat_envoye: { label: 'Mandat envoye', cls: 'bg-amber-50 text-amber-700' },
  signe: { label: 'Signé', cls: 'bg-blue-50 text-blue-700' },
  actif: { label: 'Actif', cls: 'bg-emerald-50 text-emerald-700' },
  resilie: { label: 'Resilie', cls: 'bg-red-50 text-red-600' },
};

// La marque d'un actif SANS mandat signe, sur les ecrans d'exploitation.
//
// Volontairement distincte de MANDAT_STATUS_CHIP.non_signe, qui est neutre : sur la
// fiche client, le statut du mandat est une information parmi d'autres. Au Monitoring
// et au Pilotage, c'est un dossier qui attend un geste, et un gris ne se voit pas dans
// une liste de deux cents lignes. Meme famille chromatique que le verrou agregateur :
// dans les deux cas l'actif est visible et non actionnable.
//
// Un seul endroit pour ces deux chaines : les deux ecrans doivent dire le meme mot.
export const MANDAT_MANQUANT = {
  label: 'Sans mandat',
  cls: 'bg-amber-50 text-amber-700 border-amber-200',
  aide: "Mandat non signe : cet actif est visible, mais aucune action ne peut lui etre "
    + "envoyee tant que son mandat n'est pas signe.",
};

// Chip statut mandat sur la fiche (label + cls).
export const MANDAT_STATUS_CHIP = {
  non_signe: { label: 'Non signe', cls: 'bg-neutral-100 text-neutral-500' },
  signe: { label: 'Signé', cls: 'bg-blue-50 text-blue-700' },
  actif: { label: 'Actif', cls: 'bg-emerald-50 text-emerald-700' },
  resilie: { label: 'Resilie', cls: 'bg-red-50 text-red-600' },
};
